import React, { Component, useEffect, useState } from "react";
import { View, ScrollView, TouchableHighlight } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Theme from "../argon-ui/Theme";
import SmartParking, { ParkingArea } from "../viewModels/SmartParking";
import { IconButton } from "../components_v2/Buttons";
import { translate } from "../locales/translate";

interface props {
  name: string;
  smartParkingId: string;
  parkingAreas: [];
  navigation: any;
  singleSmartParking: boolean;
}

const ParkingLotFormScreen: React.FC = (props: any) => {
  const [parkings, setParking] = useState<SmartParking | any>([]);
  useEffect(() => {
    setParking(props.AreaReducer.parkings);
  }, [props.AreaReducer]);
  return (
    <View style={{ flex: 1 }}>
      <ScrollView style={{ padding: 5 }}>
        {parkings.map((item: SmartParking | any) => {
          return (
            <ParkingListItem
              key={item.id}
              smartParkingId={item.id}
              name={item.name}
              parkingAreas={item.parkingAreas}
              navigation={props.navigation}
              singleSmartParking={parkings.length === 1 ? true : false}
            />
          );
        })}
      </ScrollView>
    </View>
  );
};
const ParkingListItem: React.FC<props> = ({
  name,
  smartParkingId,
  parkingAreas,
  navigation,
  singleSmartParking,
}: props) => {
  const [openDropDown, setOpenDropDown] = useState<boolean>(singleSmartParking);
  return (
    <View
      style={{
        borderRadius: 5,
        backgroundColor: Theme.COLORS.WHITE,
        shadowColor: Theme.COLORS.MUTED,
        marginBottom: 5,
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowOpacity: 0.2,
        shadowRadius: 6.65,
        elevation: 4,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TouchableHighlight
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          style={{
            paddingLeft: 10,
            paddingVertical: 20,
            // height: 65,
            width: "85%",
          }}
          onPress={() => !singleSmartParking && setOpenDropDown(!openDropDown)}
        >
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <View style={{}}>
              <Text
                style={{ fontSize: 16, marginBottom: 8, fontWeight: "bold" }}
              >
                {name}
              </Text>
              <Text style={{ fontSize: 16 }}>
                {translate("smartParking.numberOfFloors")}:{" "}
                {parkingAreas.length}
              </Text>
            </View>
            {!singleSmartParking && (
              <IconButton
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                }}
                icon={{
                  code: !openDropDown ? "\uf0d9" : "\uf0d8",
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 20,

                    // color: Theme.COLORS.WHITE,
                  },
                }}
              />
            )}
          </View>
        </TouchableHighlight>
        <IconButton
          style={{
            width: "15%",
            height: 40,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={() => {
            navigation.navigate("SmartParkingForm", {
              smartParkingId: smartParkingId,
            });
          }}
          icon={{
            code: "\uf044",
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 20,

              // color: Theme.COLORS.WHITE,
            },
          }}
        />
      </View>
      {openDropDown && (
        <View style={{ borderRadius: 5, marginTop: 10, padding: 5 }}>
          {parkingAreas.map((item: ParkingArea) => {
            return (
              <TouchableHighlight
                style={{
                  shadowColor: Theme.COLORS.MUTED,
                  shadowOffset: {
                    width: 0,
                    height: 3,
                  },
                  shadowOpacity: 0.2,
                  shadowRadius: 6.65,
                  elevation: 4,
                  paddingHorizontal: 10,
                  paddingVertical: 15,
                  borderRadius: 5,
                  marginBottom: 10,
                  backgroundColor: Theme.COLORS.PRIMARY,
                }}
                onPress={() => {
                  navigation.navigate("ParkingLot", {
                    itemDetails: item,
                  });
                }}
                underlayColor={Theme.COLORS.LIGHT_MAIN}
              >
                <View
                  style={{
                    flexDirection: "row",

                    justifyContent: "space-between",
                  }}
                >
                  <View>
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <Text
                        style={{
                          color: Theme.COLORS.WHITE,
                          // fontWeight: "bold",
                          marginBottom: 10,
                          fontSize: 15,
                        }}
                      >
                        {item.name}
                      </Text>
                      <Text
                        style={{
                          color: Theme.COLORS.BLACK,
                          marginHorizontal: 10,
                          backgroundColor: Theme.COLORS.LIGHT_MAIN,
                          padding: 5,
                          borderRadius: 5,
                        }}
                      >
                        {translate("smartParking.availableParking")} :{" "}
                        {item.parkingLots.length}
                      </Text>
                    </View>
                    <Text style={{ color: Theme.COLORS.WHITE }}>
                      {translate("smartParking.reservedParking")} :{" "}
                      {item.availableLots}
                    </Text>
                  </View>
                  <IconButton
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 20,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    icon={{
                      code: "\uf044",
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 20,
                        color: Theme.COLORS.WHITE,
                      },
                    }}
                  />
                </View>
              </TouchableHighlight>
            );
          })}
        </View>
      )}
    </View>
  );
};

const mapStateToProps = (state: any) => {
  return {
    reducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     removeScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.Remove(scenarioId, accessToken)),
//     runScenario: (scenarioId, accessToken) =>
//       dispatch(Actions.RunScenario(scenarioId, accessToken)),
//     toggleEnable: (scenarioId, enable, accessToken) =>
//       dispatch(Actions.ToggleEnable(scenarioId, enable, accessToken)),
//     getDetails: (scenarioId, accessToken) =>
//       dispatch(Actions.GetDetails(scenarioId, accessToken)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ParkingListScreen);
export default connect(mapStateToProps, null)(ParkingLotFormScreen);
